import React, { useRef, useState } from "react";
import Button from "../../../Button/Button";
import styles from "./Team.module.css";
import SearchIconWithIcon from "../../../SearchIconWithIcon/SearchIconWithIcon";
import KIcon from "../../../../assets/KIcon.svg";
import useFocusShortcut from "../../../../../../utils/useFocusShortcut";
import { ReactComponent as RedTrash } from "../../../../assets/redTrash.svg";
import { ReactComponent as TeamGreenIcon } from "../../../../assets/TeamGreenIcon.svg";
import { ReactComponent as PencilEdit } from "../../../../assets/pencilEdit.svg";
import ModalBlackBgTemplate from "../../../ModalBlackBgTemplate/ModalBlackBgTemplate";
import CustomDropdown from "../../../CustomDropdown/CustomDropdown";
import HeaderCard from "../../../HeaderCard/HeaderCard";
import { ReactComponent as GreenStarIcon } from "../../../../assets/GreenStarIcon.svg";
import { ReactComponent as SearchGray } from "../../../../assets/searchGray.svg";
import { ReactComponent as AddGrayIcon } from "../../../../assets/AddGrayIcon.svg";
import DeleteButton from "../../../DeleteButton/DeleteButton";
import { useTranslation } from "react-i18next";
const Team = () => {
  const [t] = useTranslation("accountSetting");

  const [searchTerm, setSearchTerm] = useState("");
  const [showInvitation, setShowInvitation] = useState(false);
  const [accessType, setAccessType] = useState(t("collaborator"));
  const [timeZone, setTimeZone] = useState("");
  const [availability, setAvailability] = useState("");
  const searchInputRef = useRef();
  useFocusShortcut(searchInputRef, "k");
  const close = () => {
    setShowInvitation(false);
  };
  const accounts = [
    {
      id: 0,
      name: "",
      email: "info@FacturaGPT.com",
      typeAccount: "Admin",
      access: "Acceso Restringido",
      state: "pending",
    },
    {
      id: 1,
      name: "FacturaGPT",
      email: "info@FacturaGPT.com",
      typeAccount: "Admin",
      access: "Acceso Completo",
    },
    {
      id: 2,
      name: "FacturaGPT",
      email: "info@FacturaGPT.com",
      typeAccount: "Colaborador",
      access: "Sin Acceso",
    },
  ];

  const getAccessClass = (access) => {
    switch (access) {
      case t("restrictedAccess"):
        return styles.restricted;
      case t("fullAccess"):
        return styles.full;
      case t("noAccess"):
        return styles.noAccess;
      default:
        return "";
    }
  };

  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => setImage(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  return (
    <div className={styles.teamContainer}>
      <p>{t("team")}</p>
      <div className={styles.colaboratorsContainer}>
        <div className={styles.inputWrapper}>
          <TeamGreenIcon />
          <input type="text" />
        </div>

        <Button
          headerStyle={{ borderRadius: "999px" }}
          action={() => setShowInvitation(true)}
        >
          {t("invite")}
        </Button>
      </div>

      <div className={styles.yourAccountInfo}>
        <div className={styles.initial}>A</div>
        <div className={styles.info}>
          <div className={styles.row}>
            <strong>{t("you")}</strong>
          </div>
          <div className={styles.row}>
            <p>{t("superadmin")}</p>
          </div>
        </div>
      </div>

      <SearchIconWithIcon
        ref={searchInputRef}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        stylesComponent={{ padding: "0" }}

        classNameIconRight={styles.searchContainerL}
      >
        <img
          src={KIcon}
          alt="filterIcon"
          className={styles.searchContainerIcon}
        />
      </SearchIconWithIcon>

      <div className={styles.accounts}>
        {accounts.map((account) => (
          <div key={account.id} className={styles.account}>
            <div className={styles.container}>
              <div className={styles.initial}>A</div>
              <div className={styles.infoAccount}>
                <div className={styles.row}>
                  <p>{account.email}</p>{" "}
                  {account.state && (
                    <span className={styles.state}>{account.state}</span>
                  )}
                </div>
                <div className={styles.row}>
                  <p>{account.typeAccount}</p>
                  <p
                    className={`${styles.access} ${getAccessClass(account.access)}`}
                  >
                    {account.access}
                  </p>
                </div>
              </div>
            </div>
            <PencilEdit />
          </div>
        ))}
      </div>
      {showInvitation && (
        <ModalBlackBgTemplate close={close}>
          <HeaderCard
            title={`example@email.com + 10 ${t("more")}`}
            setState={setShowInvitation}
          >
            <div className={styles.initial}>A</div>
            FacturaGPT
            <Button type="white">
              {t("mergePlan")}
              <GreenStarIcon />{" "}
            </Button>
            <Button>{t("save")}</Button>
            <Button>{t("invite")}</Button>
          </HeaderCard>
          <div className={styles.teamInvitation}>
            <div className={styles.row}>
              <p>{t("access")}</p>
              <div>
                {" "}
                <CustomDropdown
                  options={[t("collaborator"), t("admin"), t("superadmin")]}
                  placeholder={"Acceso PlaceHolder"}
                  selectedOption={accessType}
                  setSelectedOption={setAccessType}
                />
              </div>
            </div>
            <span>{t("requestAccess")}</span>
            <span>{t("allowForDocuments")}</span>
            <p>{t("chooseTheFolder")}</p>

            <div className={styles.inputWrapper}>
              <SearchGray />
              <input type="text" placeholder="/NombredelaCuenta" />
              <Button headerStyle={{ fontSize: "13px", background: "#4F5660" }}>
                {t('selectLocation')}
              </Button>
            </div>

            <div className={styles.optionsTeamInvitation}>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToDeleteDocuments')}</span>
              </div>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToUploadDocuments')}</span>
              </div>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToEditDocuments')}</span>
              </div>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToCreateDocuments')}</span>
              </div>

              <div className={styles.access}>
                <div className={styles.advance}>{t('advancedAccess')}</div>
                <div className={styles.full}>{t('fullAccess')}</div>
                <div className={styles.restricted}>{t('restrictedAccess')}</div>
                <div className={styles.noAccess}>{t('noAccess')}</div>
              </div>

              <div className={styles.option}>
                <label className={styles.toggleSwitch}>
                  <input type="checkbox" />
                  <span className={styles.slider}></span>
                </label>
                <p>{t('syncAutomations')}</p>
              </div>

              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToDeleteAutomations')}</span>
              </div>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToEditAutomations')}</span>
              </div>
              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToCreateAutomations')}</span>
              </div>

              <div className={styles.option}>
                <label className={styles.toggleSwitch}>
                  <input type="checkbox" />
                  <span className={styles.slider}></span>
                </label>
                <p>{t('syncContacts')}</p>
              </div>

              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToDeleteEditCreateContacts')}</span>
              </div>

              <div className={styles.option}>
                <label className={styles.toggleSwitch}>
                  <input type="checkbox" />
                  <span className={styles.slider}></span>
                </label>
                <p>{t('synchronizeAssets')}</p>
              </div>

              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToDeleteEditCreateAssets')}</span>
              </div>

              <div className={styles.option}>
                <label className={styles.toggleSwitch}>
                  <input type="checkbox" />
                  <span className={styles.slider}></span>
                </label>
                <p>{t('syncDiscounts')}</p>
              </div>

              <div className={styles.option}>
                <input type="checkbox" />
                <span>{t('accessToDeleteEditCreateDiscounts')}</span>
              </div>

              <div className={styles.option}>
                <label className={styles.toggleSwitch}>
                  <input type="checkbox" />
                  <span className={styles.slider}></span>
                </label>
                <p>{t('syncTax')}</p>
              </div>

              <div className={styles.option}>
                <input type="checkbox" />
                <span>
                  {t('accessToDeleteEditCreateTaxTypes')}
                </span>
              </div>
            </div>

            <div className={styles.timeTeamInvitation}>
              <div>
                <div className={styles.row}>
                  <p>{t('workSchedule')}</p>

                  <div className={styles.option}>
                    <label className={styles.toggleSwitch}>
                      <input type="checkbox" />
                      <span className={styles.slider}></span>
                    </label>
                  </div>
                </div>
                <span>
                  {t('ensuresComplianceWithEpmployeeTime')}
                </span>
              </div>

              <div>
                <p>{t('timeZone')}</p>
                <CustomDropdown
                  options={[
                    "(GMT+02:00) Central European Time - Madrid",
                    "(GMT+02:00) Central European Time - Madrid",
                    "(GMT+02:00) Central European Time - Madrid",
                    "(GMT+02:00) Central European Time - Madrid",
                    "(GMT+02:00) Central European Time - Madrid",
                  ]}
                  selectedOption={timeZone}
                  setSelectedOption={setTimeZone}
                />
              </div>
              <div>
                <p>{t('availabilitya')}</p>
                <CustomDropdown
                  options={[
                    t('repeatWeekly'),
                    t('repeatWeekly'),
                    t('repeatWeekly'),
                    t('repeatWeekly'),
                    t('repeatWeekly'),
                  ]}
                  selectedOption={availability}
                  setSelectedOption={setAvailability}
                />
              </div>
            </div>

            <div className={styles.days}>
              <div className={styles.row}>
                <span>{t('Lunes')}</span>
                <div>
                  <CustomDropdown options={["9:00", "9:00", "9:00", "9:00"]} />
                  <CustomDropdown options={["9:00", "9:00", "9:00", "9:00"]} />
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('tuesday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('wednesday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('thursday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('friday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('saturday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <span>{t('sunday')}</span>
                <div>
                  <span>{t('notAvailable')}</span>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.holidays}>
              <div className={styles.holidaysHeader}>
                <div>
                  <p>{t('holidays')}</p>
                  <span>
                    {t('configureAndManageHolidays')}
                  </span>
                </div>
                <div className={styles.selectHolidays}>
                  <CustomDropdown options={["9:00", "9:00", "9:00", "9:00"]} />{" "}
                  -{" "}
                  <CustomDropdown options={["9:00", "9:00", "9:00", "9:00"]} />
                  <Button
                    type="white"
                    headerStyle={{
                      borderRadius: "999px",
                      fontSize: "13px",
                      padding: "7px",
                    }}
                  >
                    {t('add')}
                  </Button>
                  <div className={styles.addBtn}>
                    <AddGrayIcon />
                  </div>
                </div>
              </div>
              <p>{t('useSavedHolidays')}</p>
              <div className={styles.tagHolidaysContainer}>
                <div className={styles.tagHoliday}>
                  25 Dec 2025 - 02 Ene 2026
                  <DeleteButton />
                </div>
                <div className={styles.tagHoliday}>
                  25 Dec 2025 - 02 Ene 2026
                  <DeleteButton />
                </div>
              </div>
            </div>

            <div className={styles.signature}>
              <div>
                <p>{t('digitalSignature')}</p>
                <span>{t('configureGuestDigitalSignature')}</span>
              </div>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <div>
                <div className={styles.signatureContainer}>
                  {image ? (
                    <>
                      <img
                        src={image}
                        alt={t('digitalSignature')}
                        className={styles.signatureImage}
                      />
                      <div className={styles.DeleteButtonContainer}>
                        <DeleteButton action={() => setImage(null)} />
                      </div>
                    </>
                  ) : (
                    <Button
                      action={handleButtonClick}
                      type="white"
                      headerStyle={{ borderRadius: "999px" }}
                    >
                      {t('add')}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.deleteContact}>
            <RedTrash className={styles.icon} /> {t('deleteAccess')}
          </div>
        </ModalBlackBgTemplate>
      )}
    </div>
  );
};

export default Team;
